
import React, { useEffect, useState } from "react";
import Chart from "react-apexcharts";
import { Loading } from "../../../../componentes/loading/loading";
import { formatarMoedaBrasileira } from "../../../../utils/formatarMoedaBrasileira";

export default function DespesaPorMes({ data, loading, filtrar }) {
    const [chartOptions, setChartOptions] = useState({});
    const [chartSeries, setChartSeries] = useState([]);

    useEffect(() => {
        if (data?.valorDespesaMesDTO && data.valorDespesaMesDTO.length > 0) {
            // Extrair meses e valores
            const meses = data.valorDespesaMesDTO.map(item => {
                const nomeMes = new Date(item.ano, item.mes - 1).toLocaleString("pt-BR", { month: "short" });
                return `${nomeMes}/${item.ano}`;
            });
            const valores = data.valorDespesaMesDTO.map(item => item.valor);

            setChartOptions({
                chart: {
                    type: "area",
                    toolbar: { show: false }
                },
                   stroke: {
      curve: "smooth",
      width: 3,
    },
                xaxis: {
                    categories: meses,
                    labels: {
                        rotate: -45
                    }
                },
                markers: {
                    size: 3,
                    hover: { size: 5 },
                },
                yaxis: {
                    tickAmount: 12,
                    labels: {
                        formatter: (value) => `R$ ${formatarMoedaBrasileira(value)}`
                    }
                },
                dataLabels: { enabled: false },
                stroke: {
                    curve: "smooth",
                    width: 2
                },
                colors: ["#3B82F6"], // Cor da linha/área
                tooltip: {
                    y: {
                        formatter: (value) => `R$ ${formatarMoedaBrasileira(value)}`
                    }
                },
               
            });

            setChartSeries([
                {
                    name: "Valor Despesa",
                    data: valores
                }
            ]);
        } else {
            setChartSeries([]);
        }
    }, [data, filtrar]);

    return (
        <div className="bg-card border border-border rounded-lg shadow-card p-4 lg:col-span-1">
            <h3 className="text-lg font-display font-semibold text-foreground mb-1">
                Evolução das Despesas por Mês
            </h3>
            <label className="text-muted-foreground text-sm">
                Análise mensal dos valores de despesa.
            </label>
            <div className="h-64">
                {!loading ? (
                    chartSeries.length > 0 ? (
                        <Chart
                            options={chartOptions}
                            series={chartSeries}
                            type="area"
                            height="100%"
                        />
                    ) : (
                        "Não existem dados disponíveis para o intervalo selecionado."
                    )
                ) : (
                    <Loading />
                )}
            </div>
        </div>
    );
}
